import { inject, Injectable, Signal } from '@angular/core';
import { environment } from '../../../../../environment/environment';
import { HttpUtil } from '../../../../shared/util/http.util';
import { Observable } from 'rxjs';
import { Page } from '../../../../shared/model/local/pagination/page';
import { BiomarkerDetails } from '../model/biomarker-details';
import { ModifyBiomarker } from '../model/modify-biomarker';
import { Biomarker } from '../model/biomarker';
import { BiomarkerPageCriteria } from '../model/biomarker-page-criteria';
import { SignalPageCriteria } from '../model/signal-page-criteria';
import { BiomarkerSignalModel } from '../model/biomarker-signal';
import { SignalModel } from '../model/signal';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BiomarkerApiService {
  apiUrl = environment.apiUrl + '/api/admin';

  private readonly _http = inject(HttpUtil);

  getBiomarkers(criteria: BiomarkerPageCriteria): Observable<Page<Biomarker>> {
    return this._http.get(`${this.apiUrl}/biomarkers/page`, criteria);
  }

  getBiomarkerDetails(id: number): Observable<BiomarkerDetails> {
    return this._http.get(`${this.apiUrl}/biomarkers/${id}`);
  }

  createBiomarker(payload: ModifyBiomarker): Observable<void> {
    return this._http.post(`${this.apiUrl}/biomarkers`, payload);
  }

  editBiomarker(payload: ModifyBiomarker, id: number): Observable<void> {
    return this._http.put(`${this.apiUrl}/biomarkers/${id}`, payload);
  }

  getSignals(
    criteria: SignalPageCriteria
  ): Observable<Page<BiomarkerSignalModel>> {
    return this._http.get(
      `${this.apiUrl}/biological-signal-weights/page`,
      criteria
    );
  }

  getAllSignals(): Observable<SignalModel[]> {
    return this._http.get(`${this.apiUrl}/biological-signals`);
  }

  getAllSignalsForBiomarker(
    biomarkerId: number
  ): Observable<BiomarkerSignalModel[]> {
    return this._http
      .get(`${this.apiUrl}/biological-signal-weights/page`, {
        pageNumber: 0,
        pageSize: 1000,
        biomarkerId,
      })
      .pipe(map(signalPage => signalPage.content));
  }
}
